import $ from 'jquery';
import 'slick-carousel';
// import loadTouchEvents from 'jquery-touch-events';
import { handleValidationErrors } from './core';
import VideoPopup from './video-popup.js';
// loadTouchEvents($);

// Not on DOM ready: a video thumbnail clicked while the page is still loading
// must open the popup on the first click.
new VideoPopup();

$(document).ready(function () {

    let isMobile = false;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)) || ((navigator.userAgent.includes("Mac") || navigator.userAgent.includes("Android")) && "ontouchend" in document)) {
        isMobile = true;
    }
    window.isMobile = isMobile;

    window.evClick = function () {
        return isMobile ? 'tap' : 'click';
    };

    $('[data-header-language-current]').click(function () {
        $('[data-header-language-drop]').toggleClass('active');
    });

    $(document).click(function (e) {
        if (!$(e.target).closest('[data-header-language-current]').length) {
            $('[data-header-language-drop]').removeClass('active')
        }
    });

    $(document).on(evClick(), '[data-link]', function (event) {
        event.preventDefault();
        let url = $(this).data('link');
        if (!url && $(this).attr('href') !== '#') {
            url = $(this).attr('href');
        } else if (!url) {
            url = $(this).data('url');
        }
        if (!url) {
            return;
        }

        if ($(this).data('target') || event.crtlKey || event.metaKey) {
            window.open(url);
        } else {
            window.location.href = url;
        }
    });

    $(window).scroll(function () {
        if ($(this).scrollTop() > 350) {
            $('[data-arrow-top]').fadeIn('slow');
        } else {
            $('[data-arrow-top]').fadeOut();
        }
    });

    $('[data-arrow-top]').click(function () {
        $('html, body').animate({scrollTop : 0},800);
        return false;
    });

    let selectedFile = null;

    $(document).on('change', '[data-form-file]', function (e) {
        let fileInput = $(this);
        let file = fileInput[0].files[0];
        if (file) {
            selectedFile = file;
            updateFileList();
        }
    });

    function updateFileList()
    {
        let fileList = $('[data-file-wrap]');
        fileList.empty();
        if (selectedFile) {
            let fileItem = $('<div class="file-name">' + selectedFile.name + '</div>')
            let removeBtn = $('<span data-clear-file></span>');
            fileItem.append(removeBtn);
            fileList.append(fileItem);
            removeBtn.on('click', function () {
                selectedFile = null;
                updateFileList();
                $('[data-form-file]').val('');
            });
        }
    }

    $(document).click(function (event) {
        let target = $(event.target);
        let openBlocks = $('[data-show]');

        if (!target.closest('.active').length) {
            openBlocks.removeClass('active');
        }
    });

    $(document).on('submit', '[data-sign-in-form]', function (e) {
        e.preventDefault();

        let form = $(this);
        let btn = form.find('button[type=submit]');
        btn.prop('disabled', true).text('Loading...');
        let redirectUrl = form.find('input[name="redirectUrl"]').val()

        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: form.serialize(),
            success: function (response) {
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                } else {
                    location.reload();
                }
            },
            error: function (xhr) {
                handleValidationErrors(xhr, form);
            },
            complete: function () {
                btn.prop('disabled', false).text('Next');
            }
        });
    });

    $(document).on('submit', '#signup-form', function (e) {
        e.preventDefault();

        let form = $(this);
        let btn = form.find('button[type=submit]');
        btn.prop('disabled', true).text('Loading...');

        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: form.serialize(),
            success: function (response) {
                if (response.redirect) {
                    window.location.href = response.redirect;
                }
            },
            error: function (xhr) {
                handleValidationErrors(xhr, form);
            },
            complete: function () {
                btn.prop('disabled', false);
            }
        });
    });


    $(document).on('submit', '#signup-form-final', function (e) {
        e.preventDefault();

        let $form = $(this);
        let $btn = $form.find('button[type=submit]');
        $btn.prop('disabled', true).text('Loading...');

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (response) {
                if (response.redirect) {
                    window.location.href = response.redirect;
                }
            },
            error: function (xhr) {
                handleValidationErrors(xhr, $form);
            },
            complete: function () {
                $btn.prop('disabled', false).text('Next');
            }
        });

        return false;
    });

    /**
     * ============================================================================
     * CAR SELECTOR
     * ============================================================================
     */

    $(function () {

        // Общая функция обработки изменения select
        function handleSelectChange($wrapper, type)
        {
            const $currentGroup = $wrapper.find(`[data-type="${type}"]`);
            const $currentSelect = $currentGroup.find('select');
            const currentVal = $currentSelect.val();

            let nextType = null;
            if (type === 'maker') nextType = 'model';
            else if (type === 'model') nextType = 'engine';
            else if (type === 'engine') nextType = null;

            if (type === 'maker') {
                const $modelGroup = $wrapper.find('[data-type="model"]');
                const $engineGroup = $wrapper.find('[data-type="engine"]');
                $modelGroup.find('.form-select select').val('0').prop('disabled', true);
                $engineGroup.find('.form-select select').val('0').prop('disabled', true);
            }

            if (type === 'model') {
                const $engineGroup = $wrapper.find('[data-type="engine"]');
                $engineGroup.find('.form-select select').val('0').prop('disabled', true);
            }

            if (!nextType) {
                if (currentVal && currentVal !== '0') {
                    const urlTemplate = $currentSelect.data('url');
                    if (urlTemplate) {
                        const url = urlTemplate.replace('__ENGINE_ID__', currentVal);

                        $wrapper.addClass('block-loader');
                        console.log(currentVal)

                        $.ajax({
                            url: url,
                            method: 'POST',
                            data: { carId: currentVal },
                            success: function (response) {
                                console.log('Engine saved:', response);
                                if (response.reload) {
                                    location.reload();
                                }
                            },
                            complete: function () {
                                $wrapper.removeClass('block-loader');
                            },
                            error: function () {
                                console.warn('Engine save failed');
                            }
                        });
                    }
                }
                return;
            }

            if (currentVal && currentVal !== '0') {
                const urlTemplate = $currentSelect.data('url');
                if (!urlTemplate) return;
                const url = urlTemplate.replace(`__${type.toUpperCase()}_ID__`, currentVal);

                const $nextGroup = $wrapper.find(`[data-type="${nextType}"]`);
                $wrapper.addClass('block-loader');

                $.ajax({
                    url: url,
                    method: 'POST',
                    success: function (response) {
                        $wrapper.removeClass('block-loader');
                        $nextGroup.find('.form-select').replaceWith(response.select);
                        $nextGroup.find('select').prop('disabled', false).trigger('change');
                    },
                    error: function () {
                        $wrapper.removeClass('block-loader');
                    }
                });
            }
        }

        function isSelected(value)
        {
            return Boolean(value) && value !== '0';
        }

        // Keyword search URL (homepage); other pages have none and reload the listing instead
        function getSearchUrl($wrapper)
        {
            return $wrapper.closest('[data-url]').data('url') || '';
        }

        // Keyword search needs only a make; the reload flow needs the full car
        function updateSearchButton($wrapper)
        {
            const values = ['maker', 'model', 'engine'].map(function (type) {
                return $wrapper.find(`[data-type="${type}"] select`).val();
            });
            const isReady = getSearchUrl($wrapper)
                ? isSelected(values[0])
                : values.every(isSelected);

            $wrapper.find('[data-car-selector-search]')
                .toggleClass('btn--disabled', !isReady)
                .attr('aria-disabled', String(!isReady));
        }

        // Builds "[Make] [Model]"; the model name is its optgroup label, e.g. "80" for "80 F103 Saloon"
        function buildSearchKeyword($wrapper)
        {
            const $maker = $wrapper.find('[data-type="maker"] select option:selected');
            const $model = $wrapper.find('[data-type="model"] select option:selected');
            const parts = [];

            if (isSelected($maker.val())) {
                parts.push($maker.text().trim());
            }
            if (isSelected($model.val())) {
                const groupLabel = $model.closest('optgroup').attr('label');
                parts.push((groupLabel || $model.text()).trim());
            }

            return parts.join(' ');
        }

        // Слушаем изменения всех select’ов
        $('[data-selector-car-vertical]').on('change', 'select', function () {
            const $wrapper = $(this).closest('[data-car-selector-wrapper]');
            const type = $(this).closest('[data-type]').data('type');

            handleSelectChange($wrapper, type);
            updateSearchButton($wrapper);
        });

        // При загрузке страницы активируем нужные поля и кнопку
        $('[data-selector-car-vertical]').each(function () {
            const $wrapper = $(this);

            if (isSelected($wrapper.find('[data-type="maker"] select').val())) {
                $wrapper.find('[data-type="model"] select').prop('disabled', false);
            }
            if (isSelected($wrapper.find('[data-type="model"] select').val())) {
                $wrapper.find('[data-type="engine"] select').prop('disabled', false);
            }

            updateSearchButton($wrapper);
        });

        // Клик по кнопке SEARCH — запускаем поиск
        $('[data-selector-car-vertical]').on('click', '[data-car-selector-search]:not(.btn--disabled)', function () {
            const $wrapper = $(this).closest('[data-car-selector-wrapper]');
            const searchUrl = getSearchUrl($wrapper);

            if (!searchUrl) {
                location.reload();
                return;
            }

            // URLSearchParams encodes spaces as "+": /search?keyword=AUDI+80
            const url = new URL(searchUrl, window.location.origin);
            url.searchParams.set('keyword', buildSearchKeyword($wrapper));
            window.location.href = url.toString();
        });

    });


    // Review cards: toggle between the original text and its English translation
    document.addEventListener('click', function (e) {
        const translateBtn = e.target.closest('[data-review-translate]');
        if (!translateBtn) return;

        e.preventDefault();

        const card = translateBtn.parentElement;
        const textBlock = card ? card.querySelector('[data-review-text]') : null;
        const label = translateBtn.querySelector('[data-review-translate-label]') || translateBtn;
        const translateText = textBlock?.getAttribute('data-translate')?.trim();

        if (!translateText || translateText === 'null') return;

        if (!textBlock.dataset.originalText) {
            textBlock.dataset.originalText = textBlock.innerHTML.trim();
        }

        const isTranslated = translateBtn.classList.toggle('is-translated');

        if (isTranslated) {
            textBlock.textContent = translateText;
        } else {
            textBlock.innerHTML = textBlock.dataset.originalText;
        }

        // Both labels are translation aliases rendered into data-* attributes of the button
        label.textContent = (isTranslated ? translateBtn.dataset.labelOriginal : translateBtn.dataset.labelTranslate) ?? '';
    });

    document.querySelectorAll('[data-tooltip]').forEach(el => {
        if (!el.hasAttribute('data-tooltip-position')) {
            el.setAttribute('data-tooltip-position', 'top');
        }

        el.addEventListener('mouseenter', () => {
            const tooltipText = el.getAttribute('data-tooltip-text');
            if (!tooltipText) return;

            const tempTooltip = document.createElement('div');
            tempTooltip.textContent = tooltipText;
            tempTooltip.style.position = 'absolute';
            tempTooltip.style.visibility = 'hidden';
            tempTooltip.style.padding = '6px 10px';
            tempTooltip.style.fontSize = '13px';
            document.body.appendChild(tempTooltip);

            const rect = el.getBoundingClientRect();
            const tooltipRect = tempTooltip.getBoundingClientRect();
            document.body.removeChild(tempTooltip);

            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            const currentPos = el.getAttribute('data-tooltip-position');
            let newPos = currentPos;

            if (currentPos === 'right' && rect.right + tooltipRect.width + 20 > viewportWidth) {
                newPos = 'left';
            } else if (currentPos === 'left' && rect.left - tooltipRect.width - 20 < 0) {
                newPos = 'right';
            } else if (currentPos === 'top' && rect.top - tooltipRect.height - 20 < 0) {
                newPos = 'bottom';
            } else if (currentPos === 'bottom' && rect.bottom + tooltipRect.height + 20 > viewportHeight) {
                newPos = 'top';
            }

            el.setAttribute('data-tooltip-position', newPos);
        });
    });

    $(document).on('click', '[data-core-add-to-cart]', function (e) {
        e.preventDefault();

        const $btn = $(this);
        const dataUrl = $btn.data('url');
        const $item = $btn.closest('[data-core-product-item]');
        const qty   = parseInt(($item.find('input[name="qty"]').val() || '1'), 10);
        const name  = ($item.find('[data-core-product-name]').text() || '').trim();

        // защита от спама кликов
        if ($btn.prop('disabled')) return;
        $btn.prop('disabled', true).addClass('is-loading');

        $.ajax({
            url: dataUrl,
            method: 'POST',
            data: {
                qty: isNaN(qty) ? 1 : qty,
                name: name,
            },
            success: function (response) {
                console.log('✅ Added to cart:', response);
            },
            error: function (xhr) {
                console.warn('⚠️ Ошибка добавления в корзину:', xhr.responseText);
            },
            complete: function () {
                $btn.prop('disabled', false).removeClass('is-loading');
            }
        });
    });
});

// export class DropdownMenu {
// 	constructor(wrapperSelector) {
// 		this.wrapper = document.querySelector(wrapperSelector);
// 		if (!this.wrapper) return;
//
// 		this.btn = this.wrapper.querySelector('button[aria-controls]');
// 		if (!this.btn) return;
// 		const menuId = this.btn.getAttribute('aria-controls');
// 		this.menu = document.getElementById(menuId);
// 		if (!this.menu) return;
//
// 		this.hoverTimeout = null;
//
// 		this.init();
// 	}
//
// 	init() {
// 		this.close();
// 		this.bindEvents();
// 	}
//
// 	bindEvents() {
// 		this.btn.addEventListener('click', (event) => {
// 			event.preventDefault();
// 			this.toggle();
// 		});
//
// 		this.wrapper.addEventListener('mouseenter', () => {
// 			clearTimeout(this.hoverTimeout);
// 			this.open();
// 		});
//
// 		this.wrapper.addEventListener('mouseleave', () => {
// 			this.hoverTimeout = setTimeout(() => {
// 				if (!this.wrapper.matches(':hover')) {
// 					this.close();
// 				}
// 			}, 100);
// 		});
//
// 		this.wrapper.addEventListener('keydown', (event) => {
// 			if (event.key === 'Escape' && this.isOpen()) {
// 				this.close();
// 				this.btn.focus();
// 			}
// 		});
//
// 		document.addEventListener('click', (event) => {
// 			if (this.isOpen() && !this.wrapper.contains(event.target)) {
// 				this.close();
// 			}
// 		});
//
// 		this.wrapper.addEventListener('focusout', (event) => {
// 			if (this.isOpen() && !this.wrapper.contains(event.relatedTarget)) {
// 				this.close();
// 			}
// 		});
// 	}
//
// 	isOpen() {
// 		return this.btn.getAttribute('aria-expanded') === 'true';
// 	}
//
// 	open() {
// 		this.btn.setAttribute('aria-expanded', 'true');
// 	}
//
// 	close() {
// 		this.btn.setAttribute('aria-expanded', 'false');
// 	}
//
// 	toggle() {
// 		if (this.isOpen()) {
// 			this.close();
// 		} else {
// 			this.open();
// 		}
// 	}
// }

export class HeaderMenu {
	constructor() {
		this.burger = document.querySelector('.header__mobile-burger');
		this.menu = document.querySelector('[data-header__menu]');
		this.dropdownWrappers = document.querySelectorAll('.has-dropdown');
		// Submenu toggle: a button, or a link to the group page (e.g. Experience)
		this.toggleSelector = 'button[aria-controls], a[aria-controls], a:not([href])';

		if (!this.menu) return;

		this.hoverTimeout = null;
		this.init();
	}

	init() {
		// Same condition as the SCSS that hides the duplicated group page in the submenu
		const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

		if (this.burger) {
			this.burger.addEventListener('click', (e) => {
				e.preventDefault();
				this.toggleMobileMenu();
			});
		}

		this.dropdownWrappers.forEach(wrapper => {
			const btn = wrapper.querySelector(this.toggleSelector);
			if (!btn) return;

			btn.addEventListener('click', (e) => {
				// With a mouse the submenu opens on hover, so a click on a group link opens its page
				if (canHover && btn.matches('a[href]')) return;

				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				this.toggleDropdown(btn);
			});

			if (canHover) {
				wrapper.addEventListener('mouseenter', () => {
					clearTimeout(this.hoverTimeout);
					this.closeAllDropdowns();
					this.openDropdown(btn);
				});

				wrapper.addEventListener('mouseleave', () => {
					this.hoverTimeout = setTimeout(() => {
						this.closeDropdown(btn);
					}, 100);
				});
			}

			// Enter on a group link opens its page, so for keyboard users the submenu opens on focus
			if (canHover && btn.matches('a[href]')) {
				wrapper.addEventListener('focusin', () => {
					clearTimeout(this.hoverTimeout);
					this.closeAllDropdowns();
					this.openDropdown(btn);
				});

				wrapper.addEventListener('focusout', (e) => {
					if (!wrapper.contains(e.relatedTarget)) {
						this.closeDropdown(btn);
					}
				});
			}
		});

		document.addEventListener('click', (e) => {
			if (!this.menu.contains(e.target) && (!this.burger || !this.burger.contains(e.target))) {
				this.closeAllDropdowns();
			}
		});

		window.addEventListener('resize', () => {
			if (window.innerWidth > 992 && this.menu.classList.contains('active')) {
				this.closeMobileMenu();
				this.closeAllDropdowns();
			}
		});
	}

	toggleMobileMenu() {
		const isActive = this.menu.classList.toggle('active');
		if (this.burger) {
			this.burger.classList.toggle('active', isActive);
			this.burger.setAttribute('aria-expanded', isActive);
		}
		// Lock page scroll
		document.body.classList.toggle('menu-open-lock', isActive);
	}

	closeMobileMenu() {
		this.menu.classList.remove('active');
		if (this.burger) {
			this.burger.classList.remove('active');
			this.burger.setAttribute('aria-expanded', 'false');
		}
		document.body.classList.remove('menu-open-lock');
	}

	toggleDropdown(btn) {
		if (btn.classList.contains('is-clicking')) return;
		btn.classList.add('is-clicking');
		setTimeout(() => btn.classList.remove('is-clicking'), 150);
		const isOpened = btn.getAttribute('aria-expanded') === 'true';

		if (isOpened) {
			this.closeDropdown(btn);
		} else {
			this.closeAllDropdowns();
			this.openDropdown(btn);
		}
	}

	openDropdown(btn) {
		btn.setAttribute('aria-expanded', 'true');
		const parentLi = btn.closest('.has-dropdown');
		if (parentLi) parentLi.classList.add('is-open');
	}

	closeDropdown(btn) {
		btn.setAttribute('aria-expanded', 'false');
		const parentLi = btn.closest('.has-dropdown');
		if (parentLi) parentLi.classList.remove('is-open');
		btn.blur();
	}

	closeAllDropdowns() {
		this.dropdownWrappers.forEach(wrapper => {
			wrapper.classList.remove('is-open');
			const btn = wrapper.querySelector(this.toggleSelector);
			if (btn) btn.setAttribute('aria-expanded', 'false');
		});
	}
}

class ListingViewControl {
	constructor() {
		this.selectors = {
			btn: '[data-listing-control-view-btn]',
			content: '[data-listing-content]',
			item: '[data-product-item]'
		};

		this.cookieName = 'core-listing-view';
		this.animationDelay = 300;

		this.init();
	}

	init() {
		$(document).on('click', this.selectors.btn, (e) => this.handleClick(e));
	}

	setCookie(name, value, days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		const expires = "expires=" + date.toUTCString();
		document.cookie = name + "=" + encodeURIComponent(value) + "; " + expires + "; path=/";
	}

	handleClick(e) {
		e.preventDefault();

		// Clicked button
		let $btn = $(e.currentTarget);
		let $buttons = $(this.selectors.btn);
		let $content = $(this.selectors.content);
		let $items = $(this.selectors.item);

		// Stop if the button is already active
		if ($btn.attr('aria-pressed') === 'true') return;

		// View mode comes from the data hook, the aria-label is translated
		let isGrid = $btn.attr('data-listing-control-view-btn') === 'grid';
		let viewName = isGrid ? 'grid' : 'list';

		this.setCookie(this.cookieName, viewName, 365);

		$buttons.attr('aria-pressed', 'false')
			.removeClass('btn--blue')
			.addClass('btn--outline');

		$btn.attr('aria-pressed', 'true')
			.removeClass('btn--outline')
			.addClass('btn--blue');

		this.toggleViewClasses($content, $items, isGrid);
	}

	toggleViewClasses($content, $items, isGrid) {
		// Плавно скрываем
		$content.addClass('_is-switching');

		setTimeout(() => {
			if (isGrid) {
				$content.removeClass('listing-list').addClass('listing-grid');
				$items.addClass('product-item--grid');
			} else {
				$content.removeClass('listing-grid').addClass('listing-list');
				$items.removeClass('product-item--grid');
			}
			$content.removeClass('_is-switching');
		}, this.animationDelay);
	}
}

class navAccordion {
	constructor(element, options = {}) {
		this.accordion = typeof element === 'string' ? document.querySelector(element) : element;

		if (!this.accordion) return;

		this.options = {
			closeOthers: true,
			...options
		};

		this.items = Array.from(this.accordion.querySelectorAll('.nav-accordion__item'));

		this.init();
	}

	init() {
		this.items.forEach(item => {
			const toggleBtn = item.querySelector('.nav-accordion__toggle');

			if (toggleBtn) {
				toggleBtn.addEventListener('click', (e) => {
					e.preventDefault();
					this.toggleItem(item);
				});
			}
		});
	}

	toggleItem(item) {
		const isActive = item.classList.contains('is-active');

		// Если включена опция closeOthers, закрываем все остальные элементы
		if (this.options.closeOthers && !isActive) {
			this.closeAll();
		}

		if (isActive) {
			this.close(item);
		} else {
			this.open(item);
		}
	}

	open(item) {
		item.classList.add('is-active');
		const toggleBtn = item.querySelector('.nav-accordion__toggle');
		if (toggleBtn) {
			toggleBtn.setAttribute('aria-expanded', 'true');
		}
	}

	close(item) {
		item.classList.remove('is-active');
		const toggleBtn = item.querySelector('.nav-accordion__toggle');
		if (toggleBtn) {
			toggleBtn.setAttribute('aria-expanded', 'false');
		}
	}

	closeAll() {
		this.items.forEach(item => {
			if (item.classList.contains('is-active')) {
				this.close(item);
			}
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new HeaderMenu();

	new ListingViewControl();

	const accordions = document.querySelectorAll('[data-nav-accordion]');

	accordions.forEach(acc => {
		new navAccordion(acc, { closeOthers: true });
	});
});
